import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhProgressBarComponent } from '@shared/components/ph-progress-bar/ph-progress-bar.component';

@NgModule({
  declarations: [PhProgressBarComponent],
  imports: [CommonModule],
  exports: [PhProgressBarComponent],
})
export class PhProgressBarModule {}
